import Swal from 'sweetalert2';

const confirmDeletion = async () => {
    const result = await Swal.fire({
        title: 'Confirm Deletion',
        html: `
            <p>You are about to permanently delete this listing.</p>
            <p>Once deleted, it cannot be recovered.</p>
            <p class="mb-0">Do you want to continue?</p>
        `,
        icon: 'warning',
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes, Delete',
        confirmButtonColor: '#dc3545',
        focusConfirm: false
    });

    return result.isConfirmed;
};

export default confirmDeletion;
